export const Age = {
  mounted(el, binding) {
    el.innerHTML = calculateAge(binding.value)
  },
  updated(el, binding) {
    el.innerHTML = calculateAge(binding.value)
  },
}

function calculateAge(date: string): string {
  const currentDate: any = new Date()
  const birthDate: any = new Date(date)
  const difference = Math.abs(currentDate - birthDate)
  const age = Math.floor(difference / (1000 * 60 * 60 * 24 * 365))
  return `${age} ans`
}
